<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }} Made Purple Ltd<span class="d-none d-sm-inline-block">, All Rights Reserved</span>
    </span>
  </p>
</template>

<script>
  export default {
    components: {},
  }
</script>
